<template>
  <v-card class="w-full p-4" outlined>
    <v-card-title class="text-h5">{{ title }}</v-card-title>

    <div class="flex justify-between items-center">
      <div class="mt-4">
        <div
          class="flex flex-col md:flex-row md:items-center justify-between gap-4"
        >
          <div class="w-full sm:w-auto flex-1">
            <div class="location-dropdown relative md:max-w-[800px]">
              <v-btn
                @click="$emit('toggle-dropdown', $event)"
                outlined
                color="primary"
                class="mb-2"
              >
                {{ localSelectedLocations.length || 0 }} Selected Locations
              </v-btn>
              <LocationDropdown
                :ref="dropdownRef"
                :stores="stores"
                :showStoreDropdown="showDropdown"
                v-model="localSelectedLocations"
                @change="handleLocationChange"
                />
            </div>
          </div>
        </div>
      </div>
  
      <div class="button-group mt-6">
        <v-btn
          :loading="isLoading"
          :disabled="isLoading || localSelectedLocations.length === 0"
          color="primary"
          @click="$emit('generate')"
        >
          <v-icon left>mdi-file-chart</v-icon>
          Generate Report for {{ localSelectedLocations.length }} locations
        </v-btn>
      </div>
    </div>

    <div class="mt-4" v-if="reportData">
      <v-alert type="success">{{ successMessage }}</v-alert>
    </div>
  </v-card>
</template>

<script>
import LocationDropdown from "@/components/LocationDropdown.vue";

export default {
  components: {
    LocationDropdown,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    stores: {
      type: Array,
      required: true,
    },
    selectedLocations: {
      type: Array,
      required: true,
    },
    showDropdown: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    reportData: {
      type: Object,
      default: null,
    },
    dropdownRef: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "Report generated successfully!",
    },
  },
  data() {
    return {
      localSelectedLocations: this.selectedLocations || [],
    };
  },
  created() {
    // Initialize localSelectedLocations
    this.localSelectedLocations = [...this.selectedLocations];
  },
  methods: {
    handleLocationChange(selectedWIDs) {
      this.localSelectedLocations = [...selectedWIDs];
      this.$emit('location-change', selectedWIDs);
    },

  },
  watch: {
    selectedLocations: {
      immediate: true,
      handler(newVal) {
        this.localSelectedLocations = [...newVal];
      },
    },
  },
};
</script>
